import { jsx, jsxs } from "react/jsx-runtime";
import { URL_ACCOUNT_REGISTRATION, URL_SIGNIN } from "@seek/adv-constants";
import { useTranslations } from "@vocab/react";
import { Hidden, Box, ButtonLink } from "braid-design-system";
import { analyticsEvents, analyticsDesktopHeaderEvents } from "../../../EmployerFooter/AuthenticatedFooterLinks/AuthenticatedFooterLinks.mjs";
import { testTags } from "../../EmployerHeader.mjs";
import { useEmployerHeaderContext, isPending, isAuthenticated } from "../../../EmployerFooter/EmployerFooter.mjs";
import { getCtaPath } from "../BrandedLogo/BrandedLogo.mjs";
import { translations } from "../../../../EmployerHeader/components/.vocab/index.mjs";
import { AccountDropdown } from "../AccountDropdown/AccountDropdown.mjs";
import { LanguageSelector } from "../LanguageSelector/LanguageSelector.mjs";
import { CustomHeaderDesktopLink } from "../Navigation/HeaderLink.mjs";
import { root, container, isReady, languageContent, actionSeparator, ctaButton } from "./HeaderActions.css.mjs";
const HeaderActions = ({
  onToggleButtonClick,
  linkRenderer: LinkRenderer,
  id,
  language,
  site,
  identityIsAuthenticated
}) => {
  const { t } = useTranslations(translations);
  const {
    authenticationStatus,
    shouldDisplayActions,
    shouldDisplayCtaButton,
    urlResolver,
    handleInteractionTracking
  } = useEmployerHeaderContext();
  const registerURL = urlResolver({
    path: URL_ACCOUNT_REGISTRATION
  });
  const signInURL = urlResolver({
    path: URL_SIGNIN
  });
  const ctaURL = urlResolver({
    path: getCtaPath(authenticationStatus)
  });
  const authStatusKnown = !isPending(authenticationStatus);
  const shouldDisplayAccountDropdown = isAuthenticated(authenticationStatus);
  return /* @__PURE__ */ jsx(Hidden, { below: "tablet", children: /* @__PURE__ */ jsxs(
    Box,
    {
      className: root,
      alignItems: "center",
      justifyContent: "flexEnd",
      paddingX: "medium",
      flexGrow: 0,
      flexShrink: 0,
      display: "flex",
      children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            display: "flex",
            alignItems: "center",
            justifyContent: "flexEnd",
            className: [
              container,
              {
                [isReady]: authStatusKnown
              }
            ],
            "data-test": "header-actions-container",
            children: [
              /* @__PURE__ */ jsx(
                Box,
                {
                  display: "flex",
                  className: languageContent,
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "small",
                  children: /* @__PURE__ */ jsx(
                    LanguageSelector,
                    {
                      language,
                      site,
                      urlResolver,
                      displayAsCompact: identityIsAuthenticated
                    }
                  )
                }
              ),
              shouldDisplayActions && /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", children: [
                /* @__PURE__ */ jsx(
                  CustomHeaderDesktopLink,
                  {
                    href: signInURL,
                    "data-analytics": analyticsEvents.TRACK_SIGN_IN,
                    "data-test": testTags.SIGN_IN,
                    linkRenderer: LinkRenderer,
                    analyticsEvent: analyticsDesktopHeaderEvents.signIn,
                    children: t("Sign in")
                  }
                ),
                /* @__PURE__ */ jsx(Box, { className: actionSeparator, children: "|" }),
                /* @__PURE__ */ jsx(
                  CustomHeaderDesktopLink,
                  {
                    href: registerURL,
                    "data-analytics": analyticsEvents.TRACK_REGISTRATION,
                    "data-test": testTags.REGISTER,
                    linkRenderer: LinkRenderer,
                    analyticsEvent: analyticsDesktopHeaderEvents.register,
                    children: t("Register")
                  }
                )
              ] }),
              shouldDisplayAccountDropdown && /* @__PURE__ */ jsx(
                AccountDropdown,
                {
                  id,
                  onToggleDropdown: onToggleButtonClick,
                  linkRenderer: LinkRenderer,
                  language
                }
              )
            ]
          }
        ),
        shouldDisplayCtaButton && /* @__PURE__ */ jsx(Box, { marginLeft: "small", className: ctaButton, children: /* @__PURE__ */ jsx(
          ButtonLink,
          {
            variant: "ghost",
            tone: "neutral",
            href: ctaURL,
            data: {
              analytics: analyticsEvents.TRACK_CREATE_JOB,
              test: testTags.CREATE_A_JOB_AD
            },
            onClick: () => {
              handleInteractionTracking(
                analyticsDesktopHeaderEvents.createAJobAd
              );
            },
            children: t("Create a job ad")
          }
        ) })
      ]
    }
  ) });
};
export {
  HeaderActions
};
